import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Grid from '@material-ui/core/Grid';

import { Field, reduxForm, SubmissionError } from 'redux-form';

import AutosuggestField from 'components/fields/AutosuggestField';

import {
  requestFetchReferralSources,
  requestSearchReferralSources,
} from 'redux/modules/referralSources';
import { accountLoginFail } from 'redux/modules/account';
import { saveRecoverOrder } from 'redux/modules/recoverOrder';

function onSubmit(values, dispatch, props) {
  const normalizeValues = (formValues) => {
    const normalizedValues = Object.assign({}, formValues);

    delete normalizedValues['Selected Name'];

    return normalizedValues;
  };

  if (values.ID !== null) {
    props.reset();
    return normalizeValues(values);
  }
  throw new SubmissionError({ ID: 'Field is required' });
}

function onChange(values, dispatch, props) {
  if (props.variant === 'default' && values.ID !== null) {
    props.submit();
  }
}

const ReferralSourceAddForm = ({
  handleSubmit,
  className,
  disabled,
  change,
  variant,
  onCreateButtonClick,
  actions,
  formValues,
  account,
  referralSource,
}) => (
  <form
    noValidate
    autoComplete="off"
    onSubmit={handleSubmit}
    className={className}
    role="presentation"
    onKeyDown={(event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        event.stopPropagation();
      }
    }}
  >
    <Grid container justify="center" spacing={24}>
      <Grid item xs={12}>
        <Field
          id="Name"
          name="Name"
          component={AutosuggestField}
          fullWidth
          disabled={disabled}
          onListAdornmentClick={() => {
            change('Name', '');
            onCreateButtonClick();
          }}
          listAdornmentText="Add new"
          renderSuggestionContent={suggestion => (
            suggestion['Name of source']
          )}
          renderInputContent={suggestion => (
            suggestion['Name of source']
          )}
          onSuggestionSelected={(suggestion) => {
            change('ID', suggestion.ID);
            if (variant === 'dialog') {
              return suggestion['Name of source'];
            }
            return '';
          }}
          fetchSuggestions={({ value, limit, offset }) => (
            value.length > 0 || referralSource.length > 0
              ? requestSearchReferralSources({
                filters: [
                  ...value.length > 0 ? [{
                    name: 'Name of source',
                    operation: 'startswith',
                    val: value,
                    case_sensitivity: false,
                  }] : [],
                  ...referralSource.length > 0 ? [{
                    name: 'ID',
                    operation: 'nin',
                    val: referralSource.map(item => item.ID),
                  }] : [],
                ],
                limit,
                offset,
              }).then(res => res.data,
                (error) => {
                  if (variant === 'dialog' && error.data.error === 'Access Error') {
                    actions.saveRecoverOrder({
                      [account.ID]: {
                        ...formValues,
                        timestamp: new Date().getTime(),
                      },
                    });
                    actions.accountLoginFail();
                  }
                  return error;
                })
              : requestFetchReferralSources({
                limit,
                offset,
              }).then(res => res.data,
                (error) => {
                  if (variant === 'dialog' && error.data.error === 'Access Error') {
                    actions.saveRecoverOrder({
                      [account.ID]: {
                        ...formValues,
                        timestamp: new Date().getTime(),
                      },
                    });
                    actions.accountLoginFail();
                  }
                  return error;
                })
          )}
          onlyConfirmedSelection
        />
      </Grid>
    </Grid>
  </form>
);

ReferralSourceAddForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  className: PropTypes.string,
  onCreateButtonClick: PropTypes.func,
  disabled: PropTypes.bool,
  variant: PropTypes.oneOf(['default', 'dialog']),
  actions: PropTypes.shape({
    accountLoginFail: PropTypes.func.isRequired,
    saveRecoverOrder: PropTypes.func.isRequired,
  }).isRequired,
  formValues: PropTypes.shape({
    'Primary Insurance ID': PropTypes.number,
  }),
  account: PropTypes.shape({
    ID: PropTypes.number.isRequired,
  }).isRequired,
  referralSource: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number,
  })),
};

ReferralSourceAddForm.defaultProps = {
  variant: 'default',
  className: '',
  disabled: false,
  onCreateButtonClick: () => {},
  formValues: {},
  referralSource: [],
};

const mapStateToProps = store => ({
  account: store.account,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ accountLoginFail, saveRecoverOrder }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
  form: 'patientReferralSourceAdd',
  onSubmit,
  onChange,
  initialValues: {
    ID: null,
  },
})(ReferralSourceAddForm));



// WEBPACK FOOTER //
// ./src/components/patient/PatientProfile/ReferralSource/ReferralSourceAddForm.js